import React from 'react'
import { MessageBox } from 'components/atoms/MessageBox'

const VerificationLinkExpiredMessage = () => (
    <MessageBox negative floating size='big' header='Permission Denied'>
        <p>The record verification link is expired.</p>
    </MessageBox>
)

export default VerificationLinkExpiredMessage